import { Step } from 'react-joyride';

export const sellerDashboardSteps: Step[] = [
  {
    target: 'body',
    content: 'Welcome to GoDyspo! Let us show you around your seller dashboard.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="upload-deal"]',
    content: 'Upload your investment properties here. Add photos, property details, and pricing to attract qualified buyers.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="active-deals"]',
    content: 'View and manage all your active property listings. Track views, edit details, and respond to buyer inquiries.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-buyers"]',
    content: 'Search for qualified buyers based on their investment criteria, purchasing power, and preferred markets.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="stats-bar"]',
    content: 'Monitor your key performance metrics: Active Deals, Pending Deals, Closed Deals, Expired Deals, Property Views, and Conversion Rate.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="recent-activity"]',
    content: 'Stay updated with your latest activity including property views, buyer inquiries, and status changes.',
    disableBeacon: true,
  },
];
